import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Wifi, Smartphone, Shield, Tv, Building2, Ticket, Camera, Zap } from 'lucide-react';

const SmartStadium = () => {
  const components = [
    {
      icon: Smartphone,
      title: 'Fan Engagement & Experience',
      features: [
        'Seamless Connectivity',
        'Immersive fan experience through AR/VR',
        'One Mobile application for all sports needs: Book Tickets, Live Statistics, Quiz & Polls, Navigation to Seats',
        'Seamless entry through Face Recognition',
        'Order Food & Merchandise',
        'Book Parking and Lockers',
        'Memberships & loyalty programmes',
        'Social Media integration'
      ]
    },
    {
      icon: Zap,
      title: 'Operational Efficiency',
      features: [
        'IT Network & Wi-Fi 6 infrastructure as the digital backbone',
        'Integrated Command & Control Center (ICCC) for centralized operations',
        'AI-powered stadium operations: predictive maintenance, real-time insights, and automation',
        'Smart utilities management (water, energy, carbon), including solar integration',
        'Smart parking, transportation, and crowd management'
      ]
    },
    {
      icon: Shield,
      title: 'Safety and Security',
      features: [
        'Seamless Entry without manual frisking with Evolv Express',
        'Enhanced Scanning with Leidos Scanners for suspicious folks',
        'Video Analytics based behaviour analytics for crowd monitoring, people falling and queue length detection',
        'AI & Machine Learning for proactive threat detection',
        'Intelligent access control systems'
      ]
    },
    {
      icon: Tv,
      title: 'Broadcasting & Digital Integration',
      features: [
        'Integration with OTT, DTH and digital platforms for broader audience reach',
        'Real-time digital signage, kiosks, and content personalization',
        'Seamless connectivity for high-quality broadcast and fan interaction'
      ]
    },
    {
      icon: Building2,
      title: 'Stadium Transformation',
      features: [
        'Multi-purpose use: Sports + Events + Concerts + Tourism + Market + Sports Complex',
        'Conversion of stadiums into "Sports Cities" – integrating commercial, cultural, and sporting functions',
        'Creation of a vibrant sports ecosystem that supports local economy and tourism'
      ]
    }
  ];

  return (
    <div className="detail-page">
      <div className="detail-header-section">
        <div className="detail-header-overlay"></div>
        <img
          src="https://images.unsplash.com/photo-1766509191761-61710294e1a8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBzdGFkaXVtfGVufDB8fHx8MTc3MTcyODk4OXww&ixlib=rb-4.1.0&q=85"
          alt="Smart Stadium"
          className="detail-header-image"
        />
        <div className="detail-header-content">
          <Link to="/" className="back-button-detail">
            <ArrowLeft size={20} />
            Back to Home
          </Link>
          <h1 className="detail-title">Smart Stadium</h1>
          <p className="detail-subtitle">
            Transforming stadiums into intelligent, multi-purpose venues that enhance fan engagement, 
            operational efficiency, and public safety
          </p>
        </div>
      </div>

      <div className="detail-container">
        <section className="detail-section">
          <h2 className="detail-section-title">Solution Components</h2>
          <div className="component-grid">
            {components.map((component, index) => (
              <div key={index} className="component-card">
                <div className="component-header">
                  <div className="component-icon-wrapper">
                    <component.icon size={28} />
                  </div>
                  <h3 className="component-title">{component.title}</h3>
                </div>
                <ul className="component-features">
                  {component.features.map((feature, idx) => (
                    <li key={idx}>{feature}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </section>

        <section className="detail-section">
          <h2 className="detail-section-title">Key Benefits</h2>
          <div className="benefits-grid">
            <div className="benefit-card">
              <h4>Enhanced Fan Experience</h4>
              <p>Seamless connectivity, mobile-first services, and immersive AR/VR experiences create unforgettable moments for every visitor.</p>
            </div>
            <div className="benefit-card">
              <h4>Operational Excellence</h4>
              <p>AI-powered ICCC enables predictive maintenance, real-time monitoring, and automated operations for maximum efficiency.</p>
            </div>
            <div className="benefit-card">
              <h4>Revenue Growth</h4>
              <p>Multi-purpose venue utilization, digital merchandising, and loyalty programs drive sustainable revenue streams.</p>
            </div>
            <div className="benefit-card">
              <h4>Public Safety</h4>
              <p>Advanced threat detection, contactless screening, and intelligent crowd management ensure the highest safety standards.</p>
            </div>
          </div>
        </section>

        <section className="detail-section">
          <h2 className="detail-section-title">Solution Architecture</h2>
          <div className="architecture-image-container">
            <img
              src="https://customer-assets.emergentagent.com/job_future-tech-dark/artifacts/quj06tqi_IMG_2889.png"
              alt="Smart Stadium Solution Components"
              className="architecture-image"
            />
          </div>
        </section>
      </div>
    </div>
  );
};

export default SmartStadium;
